"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSoftColors = void 0;
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var getSoftColors = function (color) {
    switch (color) {
        case 'green10':
            return { text: design_system_foundations_1.theme.color.green90 };
        case 'yellow10':
            return { text: design_system_foundations_1.theme.color.yellow90 };
        case 'purple10':
            return { text: design_system_foundations_1.theme.color.purple90 };
        case 'blue10':
            return { text: design_system_foundations_1.theme.color.blue90 };
        case 'red10':
            return { text: design_system_foundations_1.theme.color.red90 };
        default:
            return { text: design_system_foundations_1.theme.color.white, border: design_system_foundations_1.theme.color.transparent };
    }
};
exports.getSoftColors = getSoftColors;
